<template>
  <div>
    <!-- 搜索区 -->
    <search-component @handleQueryData="handelSearch" @handleFilterData="handleFilter" />
    <!--客户搜索筛选框-->
    <search-payment :show.sync="showFilterPop" @handlequery="handleFqueryFilter" />
    <!-- <add-btn v-hasPermi="['cont:payment:add']" @add="handleAddContract" /> -->
    <van-tabs v-model="active" @change="handleClick">
      <van-tab name="0" title="收款草稿" :badge="countItem.cgCount != 0?countItem.cgCount:''"></van-tab>
      <van-tab name="1" title="待确认" :badge="countItem.wshCount != 0?countItem.wshCount:''"></van-tab>
      <van-tab name="2" title="确认到账" :badge="countItem.tgCount != 0?countItem.tgCount:''"></van-tab>
      <van-tab name="3" title="驳回" :badge="countItem.btgCount != 0?countItem.btgCount:''"></van-tab>
    </van-tabs>
    <van-list v-model="loading" :finished="finished"  finished-text="没有更多了" @load="onLoad" v-if="list.length > 0">
      <total-component :totalValue="total" />
      <van-cell v-for="(item, index) in list" :key="index" @click="toDetails(item)" >
        <div style="display: flex; align-items: center; height:100%; width:100%">
          <div style="flex: 1;">
            <div class="custName-wrap" style="padding: 0;">
              <div class="custName">
                {{item.contPayCompanyName}}
              </div>
            </div>
            <div style="color: #333; font-size: 12px">付款金额：{{item.payMoney}} 付款日期： {{item.payDate}}</div>
            <div style="color: #333; font-size: 12px">提交时间：{{item.submitTime || '--'}} 确认时间： {{item.checkTime || '--'}}</div>
            <div style="color: #999; font-size: 12px">我方主体单位： {{item.companyName}}</div>
          </div>
          <van-icon style="flex:0.1;" color="#c1c1c1" name="arrow" size="16" class="arrow-color" />
        </div>
      </van-cell>
    </van-list>
    <empty-component v-if="isEmpty" />
    <!-- <dialog-payment :show='paymentFormShow' :isAdd="true" @handleAddContractCancel='handleAddContractCancel' @beforeClose='addContractBeforeClose'></dialog-payment> -->
  </div>
</template>

<script>
import payment from '@/api/cont/payment'
// import { getDicts } from '@/api/system/dict/data'
import SearchComponent from '@/components/common/Search'
import SearchPayment from '../components/contract/SearchPayment.vue'
import EmptyComponent from '@/components/common/Empty'
import TotalComponent from '@/components/common/Total'
import { Tab, Tabs } from 'vant'
// import AddBtn from '@/components/common/AddBtn'
// import DialogPayment from '../components/DialogPayment.vue'

export default {
  name: 'approve',
  components: {
    // AddBtn,
    SearchComponent,
    SearchPayment,
    EmptyComponent,
    TotalComponent,
    // DialogPayment,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs
  },
  data() {
    return {
      add_show: false,
      isEmpty: false,
      active: 0,
      loading: false,
      finished: false,
      list: [],
      total: 0,
      countItem: {},
      showFilterPop: false,
      custList: [],
      paymentFormShow: false,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        checkStatus: this.$route.query.status || 0,
        orderByColumn: 'createTime',
        isAsc: 'desc'
      }
    }
  },
  created() {
    if (this.$route.query.custId) {
      this.queryParams.custId = this.$route.query.custId
    }
    if (this.$route.query.status) {
      this.active = this.$route.query.status
    }
    this.handleList()
    this.getCountItem()
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      document.title = '打款记录'
    },
    // 搜索子组件传递过来的搜索关键字
    handelSearch(data) {
      this.queryParams.contPayCompanyName = data
      this.queryCustList()
    },
    // 过滤子组件传递过来的搜索对象
    handleFqueryFilter(data) {
      const query = this.queryParams
      this.queryParams = { ...query, ...data }
      this.queryCustList()
      this.showFilterPop = false
    },
    queryCustList() {
      this.list = []
      this.queryParams.pageNum = 1
      this.queryParams.pageSize = 10
      this.handleList()
      this.getCountItem()
    },
    // 接收子组件的filter事件
    handleFilter() {
      this.showFilterPop = true
    },
    toDetails(item) {
      this.$router.push({
        path: '/cont/payment/detail',
        query: { id: item.contIncomeId, active: this.active }
      })
    },
    async handleList() {
      this.loading = true
      const res = await payment.listPayment(this.queryParams)
      if (res.code === 200) {
        console.log(res)
        if (res.rows.length === 0) {
          this.isEmpty = true
        } else {
          this.isEmpty = false
        }
        this.list = this.list.concat(...res.rows)
        this.queryParams.pageNum += 1
        this.total = res.total
        this.finished = this.list.length >= res.total
        this.loading = false
      }
    },
    // 查询打款记录数量
    getCountItem() {
      // this.queryParams.checkStatus = null
      payment.getCountItem({ ...this.queryParams, checkStatus: null }).then(res => {
        if (res.code === 200) {
          this.countItem = res.data
        }
      })
    },
    onLoad() {
      this.handleList()
      this.getCountItem()
    },
    handleClick(tab, event) {
      // if (tab == '0') {
      //   this.queryParams.contractStatus = 7
      // } else if (tab == '1') {
      //   this.queryParams.contractStatus = 9
      // } else if (tab == '2') {
      //   this.queryParams.contractStatus = 30
      // }
      this.queryParams.checkStatus = tab
      this.queryCustList()
    },
    handleAddContract() {
      this.paymentFormShow = true
    },
    handleAddContractCancel() {
      this.paymentFormShow = false
    },
    // 添加合同
    async addContractBeforeClose() {
      this.paymentFormShow = false
      await this.queryCustList()
      // let _this = this;
      // // if (type === "confirm") {
      // //   try {
      //     // await this.$refs["form"].validate();
      //     addContract(form).then((response) => {
      //       if(response.code == 200){
      //         Toast.success("添加成功");
      //         _this.add_show = false;
      //       }else{
      //         Toast.fail("添加失败:"+response.msg);
      //       }
      //     });
      //     setTimeout(() => {
      //       _this.queryContractList();
      //     },500)
      //     // done();
      //   // } catch (err) {
      //   //   return done(false);
      //   // }
      // //   return done(false);
      // // } else {
      // //   return done();
      // // }
    }
  }
}
</script>
<style lang="less" scoped>
@import url("@/style/index.less");
.van-tabs {
  position: relative;
  top: 1.25rem;
}
.tips{
  min-width: 3.1rem;
  font-size: .2rem;
  color: rgb(247, 155, 35);
}
/deep/ .van-tabs__line {
    position: absolute;
    bottom: 0.4rem;
    left: 0;
    z-index: 1;
    width: 1.06667rem;
    height: 0.08rem;
    background-color: #0a315d;
    border-radius: 0.08rem;
}
/deep/.van-info{
  background-color: #1989fa;
}
.editVisit{
    min-height: 9rem;
    height: 50%;
    top: 46%;
    .formSty{
      height: 100%; overflow: scroll; margin: 10px 5px;
    }
}
.editVisit /deep/.van-dialog__content {
  height: 83%;
  .van-field--error .van-field__control{
    font-size: 0.38rem;
  }
  .van-field__control{font-size: 0.38rem;}
}
.editVisit /deep/.van-dialog__content {
  height: 70%;
}
</style>
